import React from 'react';
import ReactPlayer from 'react-player';
import { APP_IMG } from 'src/constants';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';

function SectionTwo({ data }: any) {
  // /images/gamechanger/image-right-2.jpg /images/gamechanger/image-left-2.png
  return (
    <SectionWrapper className='section-two' frame={convertDatasets(data, 'frame-video', true)}>
      <div className='content container'>
        <div className='initial-text'>
          <img className='img-the-moment' src={convertDatasets(data, 'img-the-moment', true)} />
          <img className='sections-text-2' src={convertDatasets(data, 'sections-text-2', true)} />
        </div>
        <div className='frame'>
          <div className='video'>
            <ReactPlayer width='100%' height='100%' url={convertDatasets(data, 'video_url', true) || '#'} controls={true} />
          </div>
        </div>

        {/* <div className='image-container'>
          <div className='container  display-flex'>
            <img className='img-frame' src={convertDatasets(data, 'frame-video', true)} />
          </div>
          <div className='video'>
            <ReactPlayer width='100%' height='100%' url={convertDatasets(data, 'video_url', true) || '#'} controls={true} />
          </div>
        </div> */}

        <img className='image-left' src={convertDatasets(data, 'image-left', true)} />
        <img className='image-right' src={convertDatasets(data, 'image-right', true)} />
      </div>
    </SectionWrapper>
  );
}

interface StyledProps {
  frame: string;
}

const SectionWrapper = styled.div<StyledProps>`
  position: relative;
  width: 100%;
  margin: auto;
  height: auto;
  padding: 30px 0;
  padding-bottom: 0;

  @media (max-width: 767px) {
    padding: 10px;
  }

  .image-right {
    position: absolute;
    width: 150px;
    top: -14%;
    left: -2rem;

    @media (max-width: 992px) {
      width: 90px;
      top: -60px;
      left: 6rem;
    }

    @media (max-width: 475px) {
      width: 50px;
      top: -40px;
      left: 1rem;
    }
  }

  .image-left {
    position: absolute;
    width: 200px;
    top: -18%;
    right: -4rem;

    @media (max-width: 992px) {
      width: 110px;
      top: -90px;
      right: 2rem;
    }

    @media (max-width: 475px) {
      width: 60px;
      top: -60px;
      right: -0.2rem;
    }
  }

  .img-the-moment {
    width: 25%;

    @media (max-width: 475px) {
      width: 40%;
    }
  }

  .sections-text-2 {
    width: 55%;

    @media (max-width: 475px) {
      width: 90%;
    }
  }

  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    @media (max-width: 992px) {
      padding: 0 15px;
      padding-bottom: 100px;
    }

    @media (max-width: 767px) {
      padding-bottom: 0;
      gap: 40px;
    }

    .initial-text {
      position: relative;
      width: 100%;
      display: contents;

      @media (max-width: 767px) {
        flex-direction: column;
        align-items: center;
        gap: 20px;
      }

      .title-image {
        width: 40%;

        @media (max-width: 767px) {
          width: 100%;
        }
      }

      .text {
        width: 50%;
        text-align: start;
        font-size: 22px;
        font-weight: 400;
        line-height: 1.3;

        @media (max-width: 992px) {
          width: 100%;
          font-size: 18px;
          padding: 0 10px;
        }

        @media (max-width: 475px) {
          font-size: 12px;
        }
      }
    }

    .display-flex {
      display: flex;
      justify-content: center;
    }

    .img-frame {
      width: 80%;

      @media (max-width: 992px) {
        width: 95%;
      }

      @media (max-width: 475px) {
        width: 100%;
      }
    }

    .image-container {
      position: relative;
      overflow: hidden;
    }

    .frame {
      position: relative;
      width: 100%;
      background-image: url(${props => props?.frame});
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
    }

    .frame::before {
      content: '';
      display: block;
      padding-top: 56.25%;

      @media (max-width: 475px) {
        padding-top: 70%;
      }
    }

    .video {
      position: absolute;
      top: 10%;
      left: 11%;
      width: 78%;
      height: 80%;
      border: none;
      border-radius: 10px;

      @media (max-width: 475px) {
        width: 96%;
        height: 75%;
        top: 12%;
        left: 2%;
      }
    }

    .content-text {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      width: 38%;
      gap: 50px;
      position: relative;
      transform: translate(-26%, 0);
      margin-bottom: 50px;

      @media (max-width: 767px) {
        transform: unset;
        width: 100%;
      }

      @media (max-width: 475px) {
        gap: 20px;
        margin-bottom: 30px;
      }

      .text-container {
        color: #000;
        font-size: 18px;
        font-weight: 300;
        width: 100%;

        .text-1 {
          line-height: 0.7;
          margin-bottom: 25px;

          @media (max-width: 475px) {
            margin-bottom: 12px;
          }

          .span {
            font-size: 48px;
            font-weight: 600;

            @media (max-width: 992px) {
              font-size: 26px;
            }

            @media (max-width: 475px) {
              font-size: 16px;
            }

            b {
              font-size: 72px;
              font-weight: 600;

              @media (max-width: 992px) {
                font-size: 38px;
              }

              @media (max-width: 475px) {
                font-size: 28px;
              }
            }
          }
        }

        .text-2 {
          font-size: 28px;
          font-weight: 400;
          line-height: 1.2;

          @media (max-width: 992px) {
            font-size: 18px;
          }

          @media (max-width: 475px) {
            font-size: 14px;
          }
        }
      }
    }

    .text-container-2 {
      line-height: 1;
      text-align: end;
      width: 100%;
      position: relative;
      font-size: 32px;
      font-weight: 600;

      @media (max-width: 992px) {
        font-size: 26px;
      }

      @media (max-width: 767px) {
        width: 60%;
      }

      @media (max-width: 475px) {
        font-size: 16px;
      }

      b {
        font-size: 68px;
        font-weight: 600;

        @media (max-width: 992px) {
          font-size: 38px;
        }

        @media (max-width: 475px) {
          font-size: 28px;
        }
      }
    }

    .asset-middle {
      position: absolute;
      right: -18%;
      bottom: 1%;
      width: 90%;
      transform: rotate(-90deg);
      z-index: -1;
    }

    .asset-1 {
      position: absolute;
      left: 0;
      bottom: 0;
      height: auto;
      width: 20%;
      z-index: -1;
      max-height: 650px;

      @media (max-width: 767px) {
        display: none;
      }
    }

    .asset-2 {
      position: absolute;
      right: 0;
      bottom: 8%;
      width: 40%;
      z-index: -1;

      @media (max-width: 767px) {
        width: 36%;
        bottom: 4%;
      }
    }
  }
`;

export default SectionTwo;
